import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import LocalShippingIcon from '@mui/icons-material/LocalShippingOutlined';

// Sits above the AppBar (below the ImpersonationBanner when both show) for
// default users who haven't added their name + shipping address yet. AppLayout
// owns the visibility decision so the fixed-position offsets stay in sync;
// `top` is the height of any banner stacked above this one.
export default function ProfileCompletionBanner({ top = 0 }: { top?: number }) {
  const navigate = useNavigate();
  const location = useLocation();
  // Bring the user back to whatever page they were on once they save or skip.
  const returnTo = `${location.pathname}${location.search}`;

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        position: 'fixed',
        top: `${top}px`,
        left: 0,
        right: 0,
        zIndex: 1300,
        bgcolor: 'warning.main',
        color: 'text.primary',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: 0.75,
        px: 2,
        fontSize: 13,
      }}
    >
      <LocalShippingIcon sx={{ fontSize: 18, display: { xs: 'none', sm: 'block' } }} />
      <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
        Your profile is missing details
      </Typography>
      <Typography sx={{ fontSize: 12, opacity: 0.85, display: { xs: 'none', md: 'block' } }}>
        Add your name and shipping address so we can send your course materials.
      </Typography>
      <Button
        size="small"
        onClick={() => navigate('/complete-profile', { state: { returnTo } })}
        sx={{
          ml: 1,
          color: 'inherit',
          borderColor: 'rgba(64,64,64,0.45)',
          textTransform: 'none',
          fontSize: 12,
          '&:hover': { borderColor: 'text.primary', bgcolor: 'rgba(255,255,255,0.25)' },
        }}
        variant="outlined"
      >
        Complete profile
      </Button>
    </Box>
  );
}
